import { RootState } from './store';

export const localeSelector = (state: RootState) => (
  (state.auth.me && state.auth.me.facility && state.auth.me.facility.locale) || ''
);
